
export const environment = {
    envName: 'qa',
    production: false,
    hostname: 'qa.app.toyota.com',
    apiBaseUrl: 'https://qa.app.toyota.com',
    logger: {
      level: 'DEBUG'
    },
    xApiKey: '',
    TENANT_ID: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
    CLIENT_ID: 'a71f3e2e-d297-45ea-9b99-0acc544385a7',
    REDIRECT_URL: 'https://qa.app.toyota.com',
    apiUrl: {
        lookupUrl: 'https://api.qa.app.toyota.com/lookup/',
        adminUrl:  'https://api.qa.app.toyota.com/admin/',
        suppliermanagUrl: 'https://api.qa.app.toyota.com/management/',
        acknowledgementUrl: 'https://api.qa.app.toyota.com/acknowledgement/'
    }
  };
  
